import type { HeadingTypes, SpacingTypes } from '@etg/wings';
import { Card, Heading, Inline, Stack } from '@etg/wings';
import type { ComponentProps, ReactNode } from 'react';

interface TitledCardProps extends ComponentProps<typeof Card> {
  children: ReactNode;
  className?: string;
  headingAs?: `h${HeadingTypes['level']}` | 'h5';
  headingId?: string;
  headingLevel?: HeadingTypes['level'];
  icon?: ReactNode;
  spacing?: SpacingTypes;
  title: string;
}

const TitledCard = ({
  children,
  className,
  headingAs,
  headingLevel = 2,
  icon,
  headingId,
  spacing = 16,
  title,
  ...rest
}: TitledCardProps) => (
  <Card className={className} {...rest}>
    <Stack spacing={spacing}>
      <Inline alignY="center" noWrap spacing={8}>
        {icon}
        <Heading as={headingAs} id={headingId} level={headingLevel} tabIndex={-1}>
          {title}
        </Heading>
      </Inline>
      <div>{children}</div>
    </Stack>
  </Card>
);

export default TitledCard;
